import { createReferenceListModule } from "./create-reference-list-module.js";
import {
  ATTENDANCE_DISPUTE_ACCEPT_REASON_CODES,
  ATTENDANCE_DISPUTE_CLAIM_REASON_CODES,
  ATTENDANCE_DISPUTE_REJECT_REASON_CODES,
} from "./attendance-disputes.js";
import { BILLING_STATEMENT_DISPUTE_CLAIM_REASON_CODES } from "./billing-statement-disputes.js";

export const attendanceDisputeClaimReasonsModule = createReferenceListModule({
  listKey: "attendanceDisputeClaimReasons",
  builtinIds: ATTENDANCE_DISPUTE_CLAIM_REASON_CODES,
  labelKeyForId: (id) => `trainerstunden.family.dispute.claimReason.${id}`,
  customIdPrefix: "attendance_claim_custom_",
  customDbFallback: "other",
});

export const disputeAcceptReasonsModule = createReferenceListModule({
  listKey: "disputeAcceptReasons",
  builtinIds: ATTENDANCE_DISPUTE_ACCEPT_REASON_CODES,
  labelKeyForId: (id) => `trainerstunden.attendanceDispute.acceptReason.${id}`,
  customIdPrefix: "dispute_accept_custom_",
  customDbFallback: "accepted_other",
});

export const disputeRejectReasonsModule = createReferenceListModule({
  listKey: "disputeRejectReasons",
  builtinIds: ATTENDANCE_DISPUTE_REJECT_REASON_CODES,
  labelKeyForId: (id) => `trainerstunden.attendanceDispute.rejectReason.${id}`,
  customIdPrefix: "dispute_reject_custom_",
  customDbFallback: "rejected_other",
});

export const billingStatementDisputeClaimReasonsModule = createReferenceListModule({
  listKey: "billingStatementDisputeClaimReasons",
  builtinIds: BILLING_STATEMENT_DISPUTE_CLAIM_REASON_CODES,
  labelKeyForId: (id) => `trainerstunden.family.invoiceDispute.claimReason.${id}`,
  customIdPrefix: "invoice_claim_custom_",
  customDbFallback: "other",
});

export const defaultAttendanceDisputeClaimReasonEntries = attendanceDisputeClaimReasonsModule.defaults;
export const resolveAttendanceDisputeClaimReasonEntries = attendanceDisputeClaimReasonsModule.resolveEntries;
export const resolveAttendanceDisputeClaimReasonEntriesForAdmin =
  attendanceDisputeClaimReasonsModule.resolveEntriesForAdmin;
export const resolveAttendanceDisputeClaimReasonLabel = attendanceDisputeClaimReasonsModule.resolveLabel;
export const resolveAttendanceDisputeClaimReasonLabelById = attendanceDisputeClaimReasonsModule.resolveLabelById;
export const isAllowedAttendanceDisputeClaimReasonId = attendanceDisputeClaimReasonsModule.isAllowedId;
export const mapAttendanceDisputeClaimReasonToDbCode = attendanceDisputeClaimReasonsModule.mapToDbCode;

export const defaultDisputeAcceptReasonEntries = disputeAcceptReasonsModule.defaults;
export const resolveDisputeAcceptReasonEntries = disputeAcceptReasonsModule.resolveEntries;
export const resolveDisputeAcceptReasonEntriesForAdmin = disputeAcceptReasonsModule.resolveEntriesForAdmin;
export const resolveDisputeAcceptReasonLabel = disputeAcceptReasonsModule.resolveLabel;
export const resolveDisputeAcceptReasonLabelById = disputeAcceptReasonsModule.resolveLabelById;
export const isAllowedDisputeAcceptReasonId = disputeAcceptReasonsModule.isAllowedId;
export const mapDisputeAcceptReasonToDbCode = disputeAcceptReasonsModule.mapToDbCode;

export const defaultDisputeRejectReasonEntries = disputeRejectReasonsModule.defaults;
export const resolveDisputeRejectReasonEntries = disputeRejectReasonsModule.resolveEntries;
export const resolveDisputeRejectReasonEntriesForAdmin = disputeRejectReasonsModule.resolveEntriesForAdmin;
export const resolveDisputeRejectReasonLabel = disputeRejectReasonsModule.resolveLabel;
export const resolveDisputeRejectReasonLabelById = disputeRejectReasonsModule.resolveLabelById;
export const isAllowedDisputeRejectReasonId = disputeRejectReasonsModule.isAllowedId;
export const mapDisputeRejectReasonToDbCode = disputeRejectReasonsModule.mapToDbCode;

export const defaultBillingStatementDisputeClaimReasonEntries =
  billingStatementDisputeClaimReasonsModule.defaults;
export const resolveBillingStatementDisputeClaimReasonEntries =
  billingStatementDisputeClaimReasonsModule.resolveEntries;
export const resolveBillingStatementDisputeClaimReasonEntriesForAdmin =
  billingStatementDisputeClaimReasonsModule.resolveEntriesForAdmin;
export const resolveBillingStatementDisputeClaimReasonLabel =
  billingStatementDisputeClaimReasonsModule.resolveLabel;
export const resolveBillingStatementDisputeClaimReasonLabelById =
  billingStatementDisputeClaimReasonsModule.resolveLabelById;
export const isAllowedBillingStatementDisputeClaimReasonId =
  billingStatementDisputeClaimReasonsModule.isAllowedId;
export const mapBillingStatementDisputeClaimReasonToDbCode =
  billingStatementDisputeClaimReasonsModule.mapToDbCode;

/**
 * @param {string} code
 * @param {unknown} lists
 * @param {(key: string) => string} t
 */
export function resolveBillingStatementDisputeClaimReasonDisplay(code, lists, t) {
  const c = String(code || "").trim();
  if (!c) return "";
  if (BILLING_STATEMENT_DISPUTE_CLAIM_REASON_CODES.includes(c)) {
    return resolveBillingStatementDisputeClaimReasonLabelById(c, lists, t);
  }
  if (ATTENDANCE_DISPUTE_CLAIM_REASON_CODES.includes(c)) {
    return resolveAttendanceDisputeClaimReasonLabelById(c, lists, t);
  }
  return c;
}
